import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Box,
  Grid,
  Divider,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { SERVER_URL } from "../../../api";
import { cleanHtmlAndTruncate, getNonEmpty } from "../../../utils/helpers";

const CourseInfoDialog = (props) => {
  const { curso, open, setOpen } = props;
  const history = useHistory();

  const handleEdit = () => {
    setOpen(false);
    curso.texto
      ? history.push("/edit-evento/" + curso._id)
      : history.push("/edit-curso/" + curso._id);
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("es-ES", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  // Función para obtener el idioma preferido (español si existe, sino inglés)
  const getTitle = (titulo) => {
    if (typeof titulo === "object") {
      return getNonEmpty(titulo);
    }
    return titulo || "Sin título";
  };

  if (!curso) return null;

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="course-info-dialog"
      maxWidth="md"
      fullWidth
    >
      <DialogTitle id="course-info-dialog">
        {getTitle(curso.titulo)}
      </DialogTitle>

      <DialogContent>
        <Box sx={{ p: 1 }}>
          <Grid container spacing={2}>
            {/* Imagen del curso */}
            {curso.imageURL && (
              <Grid item xs={12}>
                <Box display="flex" justifyContent="center" mb={2}>
                  <img
                    src={`${SERVER_URL}/${curso.imageURL}`}
                    alt={getTitle(curso.titulo)}
                    style={{
                      maxWidth: "100%",
                      maxHeight: "200px",
                      borderRadius: "8px",
                      objectFit: "cover",
                    }}
                  />
                </Box>
                <Divider />
              </Grid>
            )}

            {/* Información básica */}
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2" color="textSecondary">
                {curso.nRegistro ? "Número de Registro" : "Título"}
              </Typography>
              <Typography variant="body1" gutterBottom>
                {curso.nRegistro ? curso.nRegistro : getNonEmpty(curso.titulo)}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2" color="textSecondary">
                {curso.creditos ? "Créditos" : "Descripción"}
              </Typography>
              <Typography variant="body1" gutterBottom>
                {curso.creditos
                  ? curso.creditos
                  : cleanHtmlAndTruncate(getNonEmpty(curso.texto))}
              </Typography>
            </Grid>

            {/* Fechas */}
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2" color="textSecondary">
                Fecha de Inicio
              </Typography>
              <Typography variant="body1" gutterBottom>
                {formatDate(curso.fechaIni)}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2" color="textSecondary">
                Fecha de Fin
              </Typography>
              <Typography variant="body1" gutterBottom>
                {formatDate(curso.fechaFin)}
              </Typography>
            </Grid>

            {/* Información opcional */}
            {curso.organizador && (
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" color="textSecondary">
                  Organizador
                </Typography>
                <Typography variant="body1" gutterBottom>
                  {curso.organizador}
                </Typography>
              </Grid>
            )}

            {curso.duracion && (
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" color="textSecondary">
                  Duración
                </Typography>
                <Typography variant="body1" gutterBottom>
                  {curso.duracion}
                </Typography>
              </Grid>
            )}
          </Grid>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button variant="contained" color="primary" onClick={handleEdit}>
          Editar
        </Button>
        <Button
          variant="outlined"
          color="secondary"
          onClick={() => setOpen(false)}
        >
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CourseInfoDialog;
